import ViewComponent from '../ViewComponent';
import { formatPrice } from '../helpers/helpers';


class PricingView extends ViewComponent {
  constructor(model) {
    super();
    this._model = model;

    $('[data-package]').click(e => {
      let pack = $(e.target).attr('data-package');
      this.emit('purchase', {
        "size": pack,
        "id": "package",
        "type": "package"
      })
    })
  }
}

export default PricingView;